import * as React from "react";
import { singleton } from "logic/singleton";
const StreamsContext = React.createContext(void 0);
export default singleton("contexts.StreamsContext", () => StreamsContext);
